import React from "react";
import "./interactive-button.scss";
export const InteractiveButton = (props) => (

  <div onClick={()=> props.action()} className={"interactive-button"}>
    {props.children}
  </div>
);
